import SVG from "../../../Components/SVG";
import { isoToJalali } from "../../../helper/isoToJalali";
import Spinner from "../../../Components/Loader/Spinner";
import MobileCarousel from "../../../Components/Cards/Information/MobileCarousel";
export default function AccountInfo({ accountData, accLoading }) {
  function addDays(isoString, days) {
    const date = new Date(isoString);
    date.setDate(date.getDate() + days);
    return date.toISOString(); // or return date
  }
  return (
    <div className="w-full h-fit flex flex-col p-5 gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark overflow-hidden">
      <h2 className="flex gap-2.5 items-center">
        <SVG
          name="info"
          classname="size-5 stroke-zi-blue-dark dark:stroke-white"
        />
        <span className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          اطلاعات حساب
        </span>
      </h2>

      {!accLoading ? (
        <MobileCarousel
          mobileFullWidth
          compactGap
          alignStart
          itemLabel="بخش اطلاعات حساب"
        >
          <div className="w-fit text-nowrap mb:contents mx-auto">
            <div className="w-full flex flex-col gap-5">
            <div className="flex gap-2">
              <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark/60">
                سرمایه اولیه:
              </span>
              <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
                {accountData &&
                  Number(
                    accountData.account.initial_balance
                  ).toLocaleString()}{" "}
                دلار
              </span>
            </div>
            <div className="flex gap-2">
              <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark/60">
                پلتفرم معامله:
              </span>
              <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
                پلتفرم کوژیتو
              </span>
            </div>
            <div className="flex gap-2">
              <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark/60">
                نوع بازار:
              </span>
              <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
                ارز دیجیتال
              </span>
            </div>
            </div>

            <div className="card-divider hidden w-px shrink-0 self-stretch bg-[linear-gradient(180deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)] mb:block" />
          </div>

          <div className="w-fit text-nowrap mb:contents mx-auto">
            <div className="w-full flex flex-col gap-5">
            <div className="flex gap-2">
              <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark/60">
                نوع حساب:
              </span>
              <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
                {accountData &&
                  (accountData.challenge.challenge_type === "real"
                    ? "چالش"
                    : "تمرینی")}
              </span>
            </div>
            <div className="flex gap-2">
              <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark/60">
                نوع چالش:
              </span>
              <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
                {accountData &&
                  `${accountData.challenge.name} | ${accountData.challenge.category}`}
              </span>
            </div>
            <div className="flex gap-2">
              <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark/60">
                نوع فاز:
              </span>
              <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
                {accountData &&
                  (accountData.phase.phase_type === "phase1"
                    ? "فاز اول"
                    : accountData.phase.phase_type === "phase2"
                    ? "فاز دوم"
                    : "فاندد")}
              </span>
            </div>
            </div>

            <div className="card-divider hidden w-px shrink-0 self-stretch bg-[linear-gradient(180deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)] mb:block" />
          </div>

          <div className="w-fit text-nowrap mb:contents mx-auto">
            <div className="w-full flex flex-col gap-5">
            <div className="flex gap-2">
              <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark/60">
                تاریخ شروع:
              </span>
              <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
                {accountData && isoToJalali(accountData.account.created_at)}
              </span>
            </div>
            <div className="flex gap-2">
              <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark/60">
                تاریخ پایان:
              </span>
              <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
                {accountData?.phase?.phase_type !== "funded"
                  ? //if accountData.status === "live" then i should show accountData.created_at(which is in iso format) + accountData.phase.duration else show accountData.updated_at
                    accountData &&
                    (accountData.account.status === "live"
                      ? isoToJalali(
                          addDays(
                            accountData.account.created_at,
                            accountData.phase.duration
                          )
                        )
                      : isoToJalali(accountData.account.updated_at))
                  : "-"}
              </span>
            </div>
            </div>
          </div>
        </MobileCarousel>
      ) : (
        <div className="w-full h-[112px] flex justify-center items-center">
          <Spinner color="#8080804D" />
        </div>
      )}
    </div>
  );
}
